import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type PropertyExpandSectionName =
    | "additional_products"
    | "booking_and_finance"
    | "building_and_surroundings"
    | "description"
    | "location"
    | "public_transport";

export interface ITrackAmplitudePropertyExpandSectionParams {
    itemId: number;
    propertyId: number;
    sectionName: PropertyExpandSectionName;
}

export const trackAmplitudePropertyExpandSection = ({sectionName, itemId, propertyId}: ITrackAmplitudePropertyExpandSectionParams) => {
    trackAmplitudeEvent("expand_section", {
        section_name: sectionName,
        location: "property_page",
        item_id: itemId,
        property_id: propertyId
    });
};

export const trackAmplitudePropertyAccordionExpansion = (expanded: boolean, params: ITrackAmplitudePropertyExpandSectionParams) => {
    if (expanded) {
        trackAmplitudePropertyExpandSection(params);
    }
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type PropertyExpandSectionName =
    | "additional_products"
    | "booking_and_finance"
    | "building_and_surroundings"
    | "description"
    | "location"
    | "public_transport";

export interface ITrackAmplitudePropertyExpandSectionParams {
    itemId: number;
    propertyId: number;
    sectionName: PropertyExpandSectionName;
}

export const trackAmplitudePropertyExpandSection = ({sectionName, itemId, propertyId}: ITrackAmplitudePropertyExpandSectionParams) => {
    trackAmplitudeEvent("expand_section", {
        section_name: sectionName,
        location: "property_page",
        item_id: itemId,
        property_id: propertyId
    });
};

export const trackAmplitudePropertyAccordionExpansion = (expanded: boolean, params: ITrackAmplitudePropertyExpandSectionParams) => {
    if (expanded) {
        trackAmplitudePropertyExpandSection(params);
    }
};
